/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of a bulk status change.
 * @export
 * @interface UserReportBulkStatusResult
 */
export interface UserReportBulkStatusResult {
    /**
     * Number of reports that were updated
     * @type {number}
     * @memberof UserReportBulkStatusResult
     */
    updated: number;
}

/**
 * Check if a given object implements the UserReportBulkStatusResult interface.
 */
export function instanceOfUserReportBulkStatusResult(value: object): value is UserReportBulkStatusResult {
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function UserReportBulkStatusResultFromJSON(json: any): UserReportBulkStatusResult {
    return UserReportBulkStatusResultFromJSONTyped(json, false);
}

export function UserReportBulkStatusResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportBulkStatusResult {
    if (json == null) {
        return json;
    }
    return {
        
        'updated': json['updated'],
    };
}

export function UserReportBulkStatusResultToJSON(json: any): UserReportBulkStatusResult {
    return UserReportBulkStatusResultToJSONTyped(json, false);
}

export function UserReportBulkStatusResultToJSONTyped(value?: UserReportBulkStatusResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated': value['updated'],
    };
}

